/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcSDDCInfo { 
    /**
     * SDDC UUID
     */
    id: string;
    /**
     * SDDC Name
     */
    name: string;
    /**
     * AWS region in which SDDC resides
     */
    region: string;
    /**
     * SDDC state
     */
    state: string;
    /**
     * SDDC age from creation time
     */
    age_in_days: number;
    /**
     * Various number of instance type
     */
    instance_type: { [key: string]: number; };
    /**
     * Time at which SDDC was created
     */
    created_at: string;
    /**
     * User who created SDDC
     */
    created_by: string;
    /**
     * Number of vSphere clusters in SDDC
     */
    num_clusters: number;
    /**
     * Number of ESX hosts in SDDC (tracked as per-cluster info)
     */
    num_esx: number;
    /**
     * Number of ESX hosts in SDDC (tracked as flat EC2 list - VMC keeps two lists for unknown reasons)
     */
    num_esx_ec2: number;
}

